module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic-VariableFont_wght.ttf?5b315bd5a3b7fa34eef7dfd5786b90b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Italic-VariableFont_wght.ttf
// module id = 317
// module chunks = 0